
import { URLMaker } from "./helpers";
import { useDispatch, useSelector } from "react-redux";
import { showToast } from "../store/reducers/notificationSlice";
  
export const triggerCheckout = (isEditing, shareImages, dispatch) => {
    if (isEditing.id == null || isEditing === undefined) {
        dispatch(showToast({ message: "You need to save", type: "error" }));
        return;
    }

    console.log("shareImages");
    window.parent.postMessage(
        {
            type: "OPEN_CHECKOUT",
            payload: {
                user_design_id: isEditing.id,
                src: URLMaker(shareImages['sheet_0']),
            },
        },
        process.env.REACT_APP_mainDomain
    );

    console.log("Open checkout request sent");
};